<template>
  <div>
    <h3 class="title">
      <span class="fl">推荐返利账户明细</span>
      <div class="like fr" @click="go">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
      <div class="clear"></div>
    </h3>
    <el-date-picker
      v-model="date"
      type="daterange"
      range-separator="至"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      class="databox"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
    ></el-date-picker>
    <el-button type="primary" icon="el-icon-search" class="bons" @click="fount">查找</el-button>
    <el-table :data="orderobj.arr" style="width: 100%" class="tablebox">
      <el-table-column prop="date" label="时间" width="232"></el-table-column>
      <el-table-column prop="content" label="内容" width="232"></el-table-column>
      <el-table-column prop="money" label="金额" width="232"></el-table-column>
      <el-table-column prop="title" label="备注" width="232">
        <template slot-scope="scope">
          <div>{{scope.row.title | starfilters}}</div>
          <div>{{scope.row.title | endfilters}}</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageing">
      <span @click="pageindex">首页</span>
      <el-pagination
        small
        layout="prev, pager, next"
        prev-text="上一页"
        next-text="下一页"
        :background="true"
        :total="orderobj.total_pages==null?1:orderobj.total_pages"
        :page-size="1"
        @current-change="currentchange"
        :current-page="page"
      ></el-pagination>
      <span @click="pageend">尾页</span>
    </div>
  </div>
</template>

<script>
import utilFile from "@/ace/ace.js";
import { DatePicker, Button, Table, TableColumn, Pagination } from "element-ui";
export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination
  },
  data() {
    return {
      date: "",
      page: 1,
      orderobj: {}
    };
  },
  watch: {
    page(newvalue) {
      this.page = newvalue;
      this.order();
    }
  },
  filters: {
    starfilters(data) {
      var sub = data.slice(4, -4);

      return sub;
    },
    endfilters(data) {
      var sub;
      if (data.indexOf("级收入") != -1) {
        sub = data.substring(data.length - 4);
      } else {
        sub = " ";
      }
      return sub;
    }
  },
  methods: {
    go() {
      this.$router.back();
    },
    //分页
    currentchange(page) {
      this.page = page;
    },
    pageindex() {
      this.page = 1;
    },
    pageend() {
      this.page = this.orderobj.total_pages;
    },
    order() {
      var data = utilFile.encrypt(
        JSON.stringify({
          page: this.page,
          start_time: this.date[0],
          end_time: this.date[1]
        })
      );
      this.$axios({
        method: "post",
        url: `/api/extend.myExtendOrder?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        }
        if (res.data.data != undefined) {
          let arr = JSON.parse(utilFile.decrypt(res.data.data));

          this.orderobj = arr;
        }
      });
    },
    fount() {
      this.page = 1;
      this.order();
    }
  },

  mounted() {
    this.order();
  }
};
</script>

<style scoped>
h3.title {
  font-size: 16px;
  color: #000;
  padding-bottom: 20px;
  border-bottom: 1px solid #edf1f2;
  margin-bottom: 20px;
  margin-top: 26px;
  cursor: pointer;
}

h3.title span {
  box-sizing: border-box;
  padding-left: 13px;
  border-left: 5px solid #38a0ff;
  margin-top: 10px;
}

h3.title em {
  font-size: 16px;
  color: #38a0ff;
  cursor: pointer;
}

.like {
  padding: 0 10px;
  line-height: 34px;
  font-size: 16px;
  color: #000;
  text-align: center;
  border-radius: 6px;
  border: 1px solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.like i {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #000;
  line-height: 20px;
  font-size: 16px;
  margin-right: 3px;
}
.tablebox {
  margin-top: 15px;
}
</style>
<style>
.databox.el-date-editor .el-range__icon {
  display: none;
}
.databox.el-range-editor .el-range-input {
  text-align: left;
}

.databox.el-range-editor.el-input__inner {
  border: 0;
}

.databox.el-range-editor .el-range-input {
  border: 1px solid #38a0ff;
  text-indent: 1em;
}
.databox.el-date-editor .el-range-separator {
  padding: 0 8px;
}

.databox.el-range-editor.el-input__inner {
  padding-left: 0;
  padding-right: 0;
}

.bons.el-button {
  padding: 10px 20px;
  margin-left: -26px;
  position: relative;
  z-index: 1000;
}

.databox.el-date-editor .el-range__close-icon {
  display: none;
}
.tablebox.el-table th {
  text-align: center;
  background-color: #f5f5f5;
}

.tablebox.el-table td {
  text-align: center;
}
</style>